export const fmtINR = (v) => {
  const n = Number(v) || 0;
  if (Math.abs(n) >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
  if (Math.abs(n) >= 1e5) return `₹${(n / 1e5).toFixed(2)} L`;
  return `₹${Math.round(n).toLocaleString("en-IN")}`;
};

export const IDEA_STAGES = [
  { key: "spark", label: "Spark", color: "bg-amber-50 text-amber-700 border-amber-300" },
  { key: "researching", label: "Researching", color: "bg-sky-50 text-sky-700 border-sky-300" },
  { key: "validating", label: "Validating", color: "bg-indigo-50 text-indigo-700 border-indigo-300" },
  { key: "building", label: "Building", color: "bg-orange-50 text-orange-700 border-orange-300" },
  { key: "launched", label: "Launched", color: "bg-emerald-50 text-emerald-700 border-emerald-300" },
  { key: "parked", label: "Parked", color: "bg-slate-50 text-slate-600 border-slate-300" },
  { key: "killed", label: "Killed", color: "bg-rose-50 text-rose-700 border-rose-300" },
];

export const IDEA_CATEGORIES = [
  { key: "revenue_stream", label: "Revenue stream" },
  { key: "upsell", label: "Upsell" },
  { key: "product", label: "Product" },
  { key: "service", label: "Service" },
  { key: "joint_venture", label: "Joint venture" },
  { key: "marketing", label: "Marketing" },
  { key: "ops", label: "Ops" },
  { key: "other", label: "Other" },
];

export const VENTURE_STAGES = [
  { key: "concept", label: "Concept" },
  { key: "validating", label: "Validating" },
  { key: "operating", label: "Operating" },
  { key: "scaling", label: "Scaling" },
  { key: "paused", label: "Paused" },
  { key: "exited", label: "Exited" },
];

export const stageMeta = (k) => IDEA_STAGES.find((s) => s.key === k) || IDEA_STAGES[0];

export const computeScores = (i) => {
  const reach = Math.min(Math.max(Number(i.reach) || 5, 1), 10);
  const impact = Math.min(Math.max(Number(i.impact) || 5, 1), 10);
  const conf = Math.min(Math.max(Number(i.confidence_pct ?? 50), 0), 100);
  const effort = Math.min(Math.max(Number(i.effort) || 5, 1), 10);
  return {
    ice: Math.round(impact * (11 - effort) * conf / 100 * 10) / 10,
    rice: Math.round((reach * impact * (conf / 100)) / effort * 100) / 100,
  };
};
